<template>
  <div class='content-tab syssnmp'>
    <loading :mask=true :size="'big'" :isWhite=true v-if="isShowLoading"/>
    <div class="content-body">
      <scrollbar ref="scrollbar" class="scrollbar-body">
        <div class="form snmp">
          <div class="formRow snmpService">
            <div class="table-row">
              <div class="checkbox-wrapper" @click="onSelection('snmpServiceEnable')">
                <checkbox class="q-checkbox-label" :checked="data.config.serviceEnable" :label="$t('systemSnmp.checkboxSnmpServiceEnable')"></checkbox>
              </div>
            </div>
            <div class="formRow snmpConfig" :class="{disabled: !isItemChecked('snmpServiceEnable')}">
              <div class="table-row">
                <div class="title">{{$t('systemSnmp.snmpVersion')}}</div>
                <q-select class="q-select" :value="data.config.version" :options-array="versionOptions" @change="onVersionChange" :isDisabled="!isItemChecked('snmpServiceEnable')"></q-select>
              </div>
              <div class="formRow snmpCommunity" v-show="isSnmpVersionCommunity()">
                <div class="table-row">
                  <div class="title">{{$t('systemSnmp.snmpCommunity')}}</div>
                  <div class="item">
                    <input type="text" name="snmpCommunity" v-model="data.config.community.name" class="form-control" @keyup="onBlur()" @blur="onBlur()" v-validate.immediate="'community|required'" maxlength="31" :disabled="!isItemChecked('snmpServiceEnable')">
                    <div v-show="errors.has('snmpCommunity') && isItemChecked('snmpServiceEnable')" class="errorMessage">{{ getErrorMsg('snmpCommunity') }}</div>
                  </div>
                </div>
              </div>
              <div class="formRow snmpSecurityConfig" v-show="!isSnmpVersionCommunity()">
                <div class="table-row">
                  <div class="title">{{$t('systemSnmp.snmpUserName')}}</div>
                  <div class="item">
                    <input type="text" name="snmpUserName" v-model="data.config.security.name" class="form-control" @keyup="onBlur()" @blur="onBlur()" v-validate.immediate="'userName|required'" maxlength="31" :disabled="!isItemChecked('snmpServiceEnable')">
                    <div v-show="errors.has('snmpUserName') && isItemChecked('snmpServiceEnable')" class="errorMessage">{{ getErrorMsg('snmpUserName') }}</div>
                  </div>
                </div>
                <div class="table-row">
                  <div class="checkbox-wrapper" @click="onSelection('snmpAuthEnable')">
                    <checkbox class="q-checkbox-label" :checked="data.config.security.authEnable" :label="$t('systemSnmp.checkboxSnmpAuthEnable')" :disabled="!isItemChecked('snmpServiceEnable')"></checkbox>
                  </div>
                </div>
                <div class="formRow snmpAuth" :class="{disabled: !isItemChecked('snmpAuthEnable')}">
                  <div class="table-row">
                    <div class="title">{{$t('systemSnmp.snmpAuthProtocol')}}</div>
                    <q-select class="q-select" :value="data.config.security.authProtocol" :options-array="authProtocolOptions" @change="onAuthProtocolChange" :isDisabled="!isItemChecked('snmpAuthEnable')"></q-select>
                  </div>
                  <div class="table-row">
                    <div class="title">{{$t('systemSnmp.snmpAuthPassword')}}</div>
                    <div class="password">
                      <input name="snmpAuthPassword" v-model="data.config.security.authPassword" class="form-control" type="password" v-validate="{password: isSnmpConfigModify(), required: isSnmpConfigModify()}" maxlength="31" :class="{'error': errors.has('snmpAuthPassword')}" :placeholder="getAuthPasswordPlaceholder()" @focus="onFocusAuthPasswordInput(true)" @blur="onFocusAuthPasswordInput(false)" @keyup="onBlur()" autocomplete="off" :disabled="!isItemChecked('snmpAuthEnable')">
                      <div v-show="errors.has('snmpAuthPassword') && isItemChecked('snmpAuthEnable')" class="errorMessage">{{ getErrorMsg('snmpAuthPassword') }}</div>
                    </div>
                  </div>
                </div>
                <div class="table-row">
                  <div class="checkbox-wrapper" @click="onSelection('snmpPrivacyEnable')">
                    <checkbox class="q-checkbox-label" :checked="data.config.security.privacyEnable" :label="$t('systemSnmp.checkboxSnmpPrivacyEnable')" :disabled="!isItemChecked('snmpAuthEnable')"></checkbox>
                  </div>
                </div>
                <div class="formRow snmpPrivacy" :class="{disabled: !isItemChecked('snmpPrivacyEnable')}">
                  <div class="table-row">
                    <div class="title">{{$t('systemSnmp.snmpPrivacyProtocol')}}</div>
                    <div class="title"> CBC-DES </div>
                  </div>
                  <div class="table-row">
                    <div class="title">{{$t('systemSnmp.snmpPrivacyPassword')}}</div>
                    <div class="password">
                      <input name="snmpPrivacyPassword" v-model="data.config.security.privacyPassword" class="form-control" type="password" v-validate="{password: isSnmpConfigModify(), required: isSnmpConfigModify()}" maxlength="31" :class="{'error': errors.has('snmpPrivacyPassword')}" :placeholder="getPrivacyPasswordPlaceholder()" @focus="onFocusPrivacyPasswordInput(true)" @blur="onFocusPrivacyPasswordInput(false)" @keyup="onBlur()" autocomplete="off" :disabled="!isItemChecked('snmpPrivacyEnable')">
                      <div v-show="errors.has('snmpPrivacyPassword') && isItemChecked('snmpPrivacyEnable')" class="errorMessage">{{ getErrorMsg('snmpPrivacyPassword') }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="formRow snmpTrapLevel">
                <div class="table-row">
                  <div class="title">{{$t('systemSnmp.snmpTrapLevel')}}</div>
                  <div class="checkbox-wrapper" @click="onSelection('snmpTrapColdStart')">
                    <checkbox class="q-checkbox-label" :checked="data.config.trapEvent.coldStart" :label="$t('systemSnmp.snmpTrapColdStart')" :disabled="!isItemChecked('snmpServiceEnable')"></checkbox>
                  </div>
                  <div class="checkbox-wrapper" @click="onSelection('snmpTrapWarmStart')">
                    <checkbox class="q-checkbox-label" :checked="data.config.trapEvent.warmStart" :label="$t('systemSnmp.snmpTrapWarmStart')" :disabled="!isItemChecked('snmpServiceEnable')"></checkbox>
                  </div>
                  <div class="checkbox-wrapper" @click="onSelection('snmpTrapLinkUp')">
                    <checkbox class="q-checkbox-label" :checked="data.config.trapEvent.linkUp" :label="$t('systemSnmp.snmpTrapLinkUp')" :disabled="!isItemChecked('snmpServiceEnable')"></checkbox>
                  </div>
                  <div class="checkbox-wrapper" @click="onSelection('snmpTrapLinkDown')">
                    <checkbox class="q-checkbox-label" :checked="data.config.trapEvent.linkDown" :label="$t('systemSnmp.snmpTrapLinkDown')" :disabled="!isItemChecked('snmpServiceEnable')"></checkbox>
                  </div>
                </div>
              </div>
              <div class="formRow snmpTrapAddress" :class="{disabled: !isItemChecked('snmpTrapEnable')}">
                <div class="table-row">
                  <div class="title">{{$t('systemSnmp.snmpTrapAddress',1)}}</div>
                  <div class="item">
                    <input type="text" name="snmpTrapAddress1" v-model="data.config.address[0]" class="form-control" @keyup="onBlur()" @blur="onBlur()" v-validate.immediate="'ip|required'" :disabled="!isItemChecked('snmpTrapEnable')">
                    <div v-show="errors.has('snmpTrapAddress1') && isItemChecked('snmpTrapEnable')" class="errorMessage">{{ getErrorMsg('snmpTrapAddress1') }}</div>
                  </div>
                </div>
                <div class="table-row">
                  <div class="title">{{$t('systemSnmp.snmpTrapAddress',2)}}</div>
                  <div class="item">
                    <input type="text" name="snmpTrapAddress2" v-model="data.config.address[1]" class="form-control" @keyup="onBlur()" @blur="onBlur()" v-validate.immediate="'ip'" :disabled="!isItemChecked('snmpTrapEnable')">
                    <div v-show="errors.has('snmpTrapAddress2') && isItemChecked('snmpTrapEnable')" class="errorMessage">{{ getErrorMsg('snmpTrapAddress2') }}</div>
                  </div>
                </div>
                <div class="table-row">
                  <div class="title">{{$t('systemSnmp.snmpTrapAddress',3)}}</div>
                  <div class="item">
                    <input type="text" name="snmpTrapAddress3" v-model="data.config.address[2]" class="form-control" @keyup="onBlur()" @blur="onBlur()" v-validate.immediate="'ip'" :disabled="!isItemChecked('snmpTrapEnable')">
                    <div v-show="errors.has('snmpTrapAddress3') && isItemChecked('snmpTrapEnable')" class="errorMessage">{{ getErrorMsg('snmpTrapAddress3') }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="formRow snmpMIB" hidden="true">
            <div class="table-row">
              <div class="title">{{$t('systemSnmp.snmpMib')}}</div>
            </div>
            <div class="table-row">
              <div class="content">{{$t('systemSnmp.snmpMibInfo')}}</div>
            </div>
            <div class="table-row">
              <button class="q-button" type="submit" :title="$t('systemSnmp.snmpMibDownload')" @click="onDownloadClick()">{{$t('systemSnmp.snmpMibDownload')}}</button>
            </div>
          </div>
        </div>
      </scrollbar>
      <div class = 'content-body-footer'>
        <button class="q-button blue-btn-full" :title="$t('save')" @click="onSaveClick()" :disabled="!isButtonEnable()">{{$t('save')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import checkbox from './module/Checkbox'
import qSelect from './module/Select.vue'
import {
  mapState, mapMutations, mapActions
} from 'vuex'
export default {
  name: 'syssnmp',
  components: {
    checkbox,
    qSelect
  },
  data () {
    return {
      data: null,
      passwordPlaceholder: '••••••••',
      focusAuthPasswordInput: false,
      focusPrivacyPasswordInput: false,
      tempV1CommunityName: '',
      tempV2CommunityName: '',
      versionOptions: [
        {label: 'systemSnmp.snmpVersionLabel1', value: 1},
        {label: 'systemSnmp.snmpVersionLabel2', value: 2},
        {label: 'systemSnmp.snmpVersionLabel3', value: 3}
      ],
      authProtocolOptions: [
        {label: 'systemSnmp.snmpAuthProtocolLabel1', value: 'MD5'},
        {label: 'systemSnmp.snmpAuthProtocolLabel2', value: 'SHA'}
      ],
      isShowLoading: false,
      isShowLoadingQueue: []
    }
  },
  created () {
    this.initParameter()
    this.initConfig()
    this.initValidator()
    this.getData()
  },
  beforeRouteLeave (to, from, next) {
    if (this.isDataChanged) {
      next(false)
    } else {
      next()
    }
  },
  mounted () {
  },
  watch: {
    currentUser: {
      handler (value) {
        if (value && value.auth !== undefined) {
          // this.getData()
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    initConfig: function () {
      let defaultConfig = {
        original: {},
        config: {
          serviceEnable: false,
          version: 2,
          community: {
            name: ''
          },
          security: {
            name: '',
            authEnable: false,
            authProtocol: 'MD5',
            authPassword: '',
            privacyEnable: false,
            privacyProtocol: 'DES',
            privacyPassword: ''
          },
          trapEvent: {
            coldStart: false,
            warmStart: false,
            linkUp: false,
            linkDown: false
          },
          address: []
        }
      }
      for (let i = 0; i < 3; i++) {
        defaultConfig.config.address.push('')
      }
      let config = JSON.parse(JSON.stringify(defaultConfig))
      this.data = config
    },
    initValidator: function () {
      let me = this
      this.$validator.extend('community', {
        getMessage (field, val) {
          return me.$t('errorMessage.snmpNameInvaild')
        },
        validate (value, field) {
          var temp = /^[A-Za-z0-9]{1,31}$/
          if (temp.test(value)) {
            return true
          }
          return false
        }
      })
      this.$validator.extend('userName', {
        getMessage (field, val) {
          return me.$t('errorMessage.snmpNameInvaild')
        },
        validate (value, field) {
          var temp = /^[A-Za-z0-9]{1,31}$/
          if (temp.test(value)) {
            return true
          }
          return false
        }
      })
      this.$validator.extend('password', {
        getMessage (field, val) {
          return me.$t('errorMessage.snmpPasswordRange')
        },
        validate (value, field) {
          var temp = /^[A-Za-z\d~!@#$%^&*()_+=\-`[\]\\{}|;':",./<>? ]{8,31}$/
          if (temp.test(value)) {
            return true
          }
          return false
        }
      })
      this.$validator.extend('ip', {
        getMessage (field, val) {
          return me.$t('errorMessage.ipFormat')
        },
        validate (value, field) {
          var temp = /^([1-9]|[1-9][0-9]|1[0-9][0-9]|2[0-2][0-3])\.([01]?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])\.([01]?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])\.([01]?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])$/
          if (temp.test(value)) {
            return true
          }
          return false
        }
      })
    },
    initParameter: function () {
      this.focusAuthPasswordInput = false
      this.focusPrivacyPasswordInput = false
      this.tempV1CommunityName = ''
      this.tempV2CommunityName = ''
    },
    getData: function () {
      this.initParameter()
      this.initConfig()
      let me = this
      this.isShowLoadingConfig('getData', true)
      this.isShowLoadingConfig('getSystemSnmpService', true)
      this.getSystemSnmpService()
        .then(res => {
          if (res.data && res.data.error_code === 200 && res.data.result) {
            me.data.config.serviceEnable = res.data.result.EnableService
            me.data.original = JSON.parse(JSON.stringify(me.data.config))
          }
          me.isShowLoadingConfig('getSystemSnmpService', false)
        })
        .catch(error => {
          me.$log.error(error)
          me.isShowLoadingConfig('getSystemSnmpService', false)
        })
      this.isShowLoadingConfig('getSystemSnmpCommunity', true)
      this.getSystemSnmpCommunity()
        .then(res => {
          if (res.data && res.data.error_code === 200 && res.data.result) {
            let data = null
            res.data.result.forEach(element => {
              if (element.key === 'USER') {
                data = element
              }
            })
            me.data.config.community.name = data.val.CommunityName
            if (data.val.Version !== 0) {
              me.data.config.version = data.val.Version
            } else {
              me.data.config.version = 3
            }
            me.data.original = JSON.parse(JSON.stringify(me.data.config))
          }
          me.isShowLoadingConfig('getSystemSnmpCommunity', false)
        })
        .catch(error => {
          me.$log.error(error)
          me.isShowLoadingConfig('getSystemSnmpCommunity', false)
        })
      this.isShowLoadingConfig('getSystemSnmpSecurity', true)
      this.getSystemSnmpSecurity()
        .then(res => {
          if (res.data && res.data.error_code === 200 && res.data.result) {
            let data = res.data.result[0]
            me.data.config.version = 3
            me.data.config.security.name = data.key
            me.data.config.security.authEnable = data.val.AuthProtocol !== 'none'
            if (data.val.AuthProtocol !== 'none') {
              me.data.config.security.authProtocol = data.val.AuthProtocol
            }
            me.data.config.security.privacyEnable = data.val.PrivacyProtocol !== 'none'
            if (data.val.PrivacyProtocol !== 'none') {
              me.data.config.security.privacyProtocol = data.val.PrivacyProtocol
            }
            me.data.original = JSON.parse(JSON.stringify(me.data.config))
          }
          me.isShowLoadingConfig('getSystemSnmpSecurity', false)
        })
        .catch(error => {
          me.$log.error(error)
          me.isShowLoadingConfig('getSystemSnmpSecurity', false)
        })
      this.isShowLoadingConfig('getSystemSnmpTrapEvent', true)
      this.getSystemSnmpTrapEvent()
        .then(res => {
          if (res.data && res.data.error_code === 200 && res.data.result) {
            let data = res.data.result
            me.data.config.trapEvent.coldStart = data.ColdStart
            me.data.config.trapEvent.warmStart = data.WarmStart
            me.data.config.trapEvent.linkUp = data.LinkUp
            me.data.config.trapEvent.linkDown = data.LinkDown
            me.data.original = JSON.parse(JSON.stringify(me.data.config))
          }
          me.isShowLoadingConfig('getSystemSnmpTrapEvent', false)
        })
        .catch(error => {
          me.$log.error(error)
          me.isShowLoadingConfig('getSystemSnmpTrapEvent', false)
        })
      this.isShowLoadingConfig('getSystemSnmpAddress', true)
      this.getSystemSnmpAddress()
        .then(res => {
          if (res.data && res.data.error_code === 200 && res.data.result) {
            res.data.result.forEach(element => {
              let index = Number(element.key)
              if (index > 0 && index <= 3) {
                me.data.config.address[index - 1] = element.val.Address
              }
            })
            me.data.original = JSON.parse(JSON.stringify(me.data.config))
          }
          me.isShowLoadingConfig('getSystemSnmpAddress', false)
        })
        .catch(error => {
          me.$log.error(error)
          me.isShowLoadingConfig('getSystemSnmpAddress', false)
        })
      this.isShowLoadingConfig('getData', false)
    },
    isShowLoadingConfig: function (name, state) {
      let result = false
      if (state) {
        this.isShowLoadingQueue.push(true)
      } else {
        if (name !== 'all') {
          this.isShowLoadingQueue.pop()
        } else {
          this.isShowLoadingQueue = []
        }
      }
      this.isShowLoadingQueue.forEach(element => {
        result = result | element
      })
      this.isShowLoading = result
    },
    checkValidation: function () {
      setTimeout(() => {
        this.onBlur()
      }, 0)
    },
    isSnmpVersionCommunity: function () {
      return (this.data.config.version !== 3)
    },
    getErrorMsg: function (field) {
      let result = ''
      result = this.errors.first(field)
      if (field === 'snmpCommunity') {
        let value = this.data.config.community.name
        if (value.length < 1 || value.length > 31) {
          result = this.$t('systemSnmp.snmpCommunityStrLen')
        }
      } else if (field === 'snmpUserName') {
        let value = this.data.config.security.name
        if (value.length < 1 || value.length > 31) {
          result = this.$t('systemSnmp.snmpUserNameLen')
        }
      } else if (field === 'snmpAuthPassword') {
        let value = this.data.config.security.authPassword
        if (value.length < 8 || value.length > 31) {
          result = this.$t('systemSnmp.snmpAuthPassLen')
        }
      } else if (field === 'snmpPrivacyPassword') {
        let value = this.data.config.security.privacyPassword
        if (value.length < 8 || value.length > 31) {
          result = this.$t('systemSnmp.snmpPrivacyPassLen')
        }
      } else if (field === 'snmpTrapAddress1') {
        let value = this.data.config.address[0]
        if (value.length < 1) {
          result = this.$t('errorMessage.isReguired')
        }
      } else if (field === 'snmpTrapAddress2') {
        result = this.errors.first(field)
      } else if (field === 'snmpTrapAddress3') {
        result = this.errors.first(field)
      }
      return result
    },
    onDownloadClick: function () {
    },
    onSaveClick: function () {
      this.$log.info('onSaveClick')
      this.goSave()
    },
    goSave: function () {
      if (this.isModalOpen) {
        this.onClose()
      }
      this.isShowLoadingConfig('goSave', true)
      if (this.data.original.serviceEnable !== this.data.config.serviceEnable) {
        let setService = {
          EnableService: this.data.config.serviceEnable
        }
        this.isShowLoadingConfig('setSystemSnmpService', true)
        this.setSystemSnmpService(setService)
          .then(res => {
            this.isShowLoadingConfig('setSystemSnmpService', false)
          })
          .catch(error => {
            this.$log.error(error)
            this.isShowLoadingConfig('setSystemSnmpService', false)
          })
        if (this.data.config.serviceEnable) {
          setTimeout(() => {
            // wait trap address enable
          }, 500)
        }
      }
      if (this.data.config.serviceEnable) {
        if (this.data.original.version !== this.data.config.version) {
          this.goSetSnmpCommunity()
          if (this.data.original.version === 3 || this.data.config.version === 3) {
            this.goSetSnmpSecurity()
          }
        } else {
          if (this.data.config.version !== 3 && !this.$compareObj(this.data.original.community, this.data.config.community)) {
            this.goSetSnmpCommunity()
          } else if (this.data.config.version === 3 && !this.$compareObj(this.data.original.security, this.data.config.security)) {
            this.goSetSnmpSecurity()
          }
        }
        if (!this.$compareObj(this.data.original.trapEvent, this.data.config.trapEvent)) {
          let setTrapEvent = {
            ColdStart: this.data.config.trapEvent.coldStart,
            WarmStart: this.data.config.trapEvent.warmStart,
            LinkUp: this.data.config.trapEvent.linkUp,
            LinkDown: this.data.config.trapEvent.linkDown
          }
          this.isShowLoadingConfig('setSystemSnmpTrapEvent', true)
          this.setSystemSnmpTrapEvent(setTrapEvent)
            .then(res => {
              this.isShowLoadingConfig('setSystemSnmpTrapEvent', false)
            })
            .catch(error => {
              this.$log.error(error)
              this.isShowLoadingConfig('setSystemSnmpTrapEvent', false)
            })
        }
        if (this.isItemChecked('snmpTrapEnable')) {
          if (!this.$compareObj(this.data.original.address, this.data.config.address)) {
            this.goSetSnmpAddress()
          } else if (this.data.original.version !== this.data.config.version) {
            this.goSetSnmpAddress()
          } else if (this.data.config.version === 3 && this.data.config.security.name !== this.data.original.security.name) {
            this.goSetSnmpAddress()
          }
        }
      }
      this.isShowLoadingConfig('goSave', false)
      let me = this
      let getDataTimeout = 30000
      let count = Math.floor(getDataTimeout / this.intervalTime)
      this.isShowLoadingConfig('getDataInterval', true)
      this.getDataInterval = setInterval(() => {
        count--
        this.isShowLoadingConfig('getDataInterval', false)
        if (!me.isShowLoading || count < 0) {
          me.isShowLoadingConfig('all', false)
          me.getData()
          clearInterval(me.getDataInterval)
        } else {
          this.isShowLoadingConfig('getDataInterval', true)
        }
      }, this.intervalTime)
    },
    goSetSnmpSecurity: function () {
      let delSecurity = this.data.original.security.name
      let setSecurity = {
        idx: this.data.config.security.name,
        AuthProtocol: this.data.config.security.authProtocol,
        AuthKey: this.data.config.security.authPassword,
        PrivacyProtocol: this.data.config.security.privacyProtocol,
        PrivacyKey: this.data.config.security.privacyPassword
      }
      let delSecurityFlag = false
      let setSecurityType = 'PUT'
      if (this.data.original.version === 3 && this.data.config.version !== 3) {
        delSecurityFlag = true
        setSecurityType = 'NONE'
      } else {
        if (this.data.original.security.name !== this.data.config.security.name) {
          if (this.data.original.security.name !== '') {
            delSecurityFlag = true
          }
          setSecurityType = 'POST'
        }
        if (!this.data.config.security.authEnable) {
          setSecurity.AuthProtocol = 'none'
          setSecurity.PrivacyProtocol = 'none'
        } else if (!this.data.config.security.privacyEnable) {
          setSecurity.PrivacyProtocol = 'none'
        }
      }
      if (delSecurityFlag) {
        this.isShowLoadingConfig('delSystemSnmpSecurity', true)
        this.delSystemSnmpSecurity(delSecurity)
          .then(res => {
            this.isShowLoadingConfig('delSystemSnmpSecurity', false)
          })
          .catch(error => {
            this.$log.error(error)
            this.isShowLoadingConfig('delSystemSnmpSecurity', false)
          })
      }
      if (setSecurityType === 'POST') {
        this.isShowLoadingConfig('addSystemSnmpSecurity', true)
        this.addSystemSnmpSecurity(setSecurity)
          .then(res => {
            this.isShowLoadingConfig('addSystemSnmpSecurity', false)
          })
          .catch(error => {
            this.$log.error(error)
            this.isShowLoadingConfig('addSystemSnmpSecurity', false)
          })
      } else if (setSecurityType === 'PUT') {
        this.isShowLoadingConfig('setSystemSnmpSecurity', true)
        this.setSystemSnmpSecurity(setSecurity)
          .then(res => {
            this.isShowLoadingConfig('setSystemSnmpSecurity', false)
          })
          .catch(error => {
            this.$log.error(error)
            this.isShowLoadingConfig('setSystemSnmpSecurity', false)
          })
      }
    },
    goSetSnmpCommunity: function () {
      let setCommunity = {
        CommunityName: this.data.config.community.name,
        Version: this.data.config.version
      }
      let setCommunityType = 'PUT'
      if (this.data.original.version !== 3 && this.data.config.version === 3) {
        setCommunityType = 'DELETE'
      } else if (this.data.original.version === 3 && this.data.config.version !== 3) {
        setCommunityType = 'POST'
      } else {
        if (this.data.original.community.name === '') {
          setCommunityType = 'POST'
        }
      }
      if (setCommunityType === 'POST') {
        this.isShowLoadingConfig('addSystemSnmpCommunity', true)
        this.addSystemSnmpCommunity(setCommunity)
          .then(res => {
            this.isShowLoadingConfig('addSystemSnmpCommunity', false)
          })
          .catch(error => {
            this.$log.error(error)
            this.isShowLoadingConfig('addSystemSnmpCommunity', false)
          })
      } else if (setCommunityType === 'PUT') {
        this.isShowLoadingConfig('setSystemSnmpCommunity', true)
        this.setSystemSnmpCommunity(setCommunity)
          .then(res => {
            this.isShowLoadingConfig('setSystemSnmpCommunity', false)
          })
          .catch(error => {
            this.$log.error(error)
            this.isShowLoadingConfig('setSystemSnmpCommunity', false)
          })
      } else if (setCommunityType === 'DELETE') {
        this.isShowLoadingConfig('delSystemSnmpCommunity', true)
        this.delSystemSnmpCommunity()
          .then(res => {
            this.isShowLoadingConfig('delSystemSnmpCommunity', false)
          })
          .catch(error => {
            this.$log.error(error)
            this.isShowLoadingConfig('delSystemSnmpCommunity', false)
          })
      }
    },
    goSetSnmpAddress: function () {
      for (let i = 0; i < this.data.config.address.length; i++) {
        let setAddress = {
          idx: (i + 1).toString(),
          Address: this.data.config.address[i],
          UserName: this.data.config.security.name,
          Version: this.data.config.version
        }
        if (setAddress.Version !== 3) {
          setAddress.UserName = ''
        }
        if (this.data.original.address[i] === '' && this.data.config.address[i] !== '') {
          this.isShowLoadingConfig('addSystemSnmpAddress', true)
          this.addSystemSnmpAddress(setAddress)
            .then(res => {
              this.isShowLoadingConfig('addSystemSnmpAddress', false)
            })
            .catch(error => {
              this.$log.error(error)
              this.isShowLoadingConfig('addSystemSnmpAddress', false)
            })
        } else if (this.data.original.address[i] !== '' && this.data.config.address[i] !== '') {
          this.isShowLoadingConfig('setSystemSnmpAddress', true)
          this.setSystemSnmpAddress(setAddress)
            .then(res => {
              this.isShowLoadingConfig('setSystemSnmpAddress', false)
            })
            .catch(error => {
              this.$log.error(error)
              this.isShowLoadingConfig('setSystemSnmpAddress', false)
            })
        } else if (this.data.original.address[i] !== '' && this.data.config.address[i] === '') {
          this.isShowLoadingConfig('delSystemSnmpAddress', true)
          this.delSystemSnmpAddress(setAddress.idx)
            .then(res => {
              this.isShowLoadingConfig('delSystemSnmpAddress', false)
            })
            .catch(error => {
              this.$log.error(error)
              this.isShowLoadingConfig('delSystemSnmpAddress', false)
            })
        }
      }
    },
    onBlur: function () {
      this.$validator.validateAll()
    },
    onFocusAuthPasswordInput: function (value) {
      this.focusAuthPasswordInput = value
    },
    onFocusPrivacyPasswordInput: function (value) {
      this.focusPrivacyPasswordInput = value
    },
    getAuthPasswordPlaceholder: function () {
      let result = ''
      if (this.data.original.security.authEnable && !this.focusAuthPasswordInput && !this.isSnmpConfigModify()) {
        result = this.passwordPlaceholder
      }
      return result
    },
    getPrivacyPasswordPlaceholder: function () {
      let result = ''
      if (this.data.original.security.privacyEnable && !this.focusPrivacyPasswordInput && !this.isSnmpConfigModify()) {
        result = this.passwordPlaceholder
      }
      return result
    },
    onVersionChange: function (value) {
      if (value !== this.data.config.version) {
        if (this.data.config.version === 1) {
          this.tempV1CommunityName = this.data.config.community.name
        } else if (this.data.config.version === 2) {
          this.tempV2CommunityName = this.data.config.community.name
        }
        if (value === 1) {
          this.data.config.community.name = this.tempV1CommunityName
        } else if (value === 2) {
          this.data.config.community.name = this.tempV2CommunityName
        }
      }
      this.data.config.version = value
      this.checkValidation()
    },
    onAuthProtocolChange: function (value) {
      this.data.config.security.authProtocol = value
      this.checkValidation()
    },
    isSnmpConfigModify: function () {
      let result = false
      if (this.data.original.version !== this.data.config.version) {
        result = true
      } else if (this.data.config.version !== 3) {
        if (!this.$compareObj(this.data.original.community, this.data.config.community)) {
          result = true
        }
      } else if (this.data.config.version === 3) {
        if (!this.$compareObj(this.data.original.security, this.data.config.security)) {
          if ((this.data.original.security.name !== this.data.config.security.name) ||
          (this.data.original.security.authEnable !== this.data.config.security.authEnable)) {
            result = true
          }
          if (this.data.config.security.authEnable) {
            if ((this.data.original.security.authProtocol !== this.data.config.security.authProtocol) ||
            (this.data.original.security.authPassword !== this.data.config.security.authPassword) ||
            (this.data.original.security.privacyEnable !== this.data.config.security.privacyEnable)) {
              result = true
            }
            if (this.data.config.security.privacyEnable) {
              if ((this.data.original.security.privacyProtocol !== this.data.config.security.privacyProtocol) ||
              (this.data.original.security.privacyPassword !== this.data.config.security.privacyPassword)) {
                result = true
              }
            }
          }
        }
      }
      return result
    },
    isButtonEnable: function () {
      var isEnable = false
      if (this.data.original.serviceEnable !== this.data.config.serviceEnable) {
        isEnable = true
      }
      if (this.data.config.serviceEnable) {
        if (this.isSnmpConfigModify()) {
          isEnable = true
        }
        if (!this.$compareObj(this.data.original.trapEvent, this.data.config.trapEvent)) {
          isEnable = true
        }
        if (this.isItemChecked('snmpTrapEnable')) {
          if (!this.$compareObj(this.data.original.address, this.data.config.address)) {
            isEnable = true
          }
        }
      }
      if (this.data.config.serviceEnable) {
        if (this.isItemChecked('snmpTrapEnable')) {
          if (this.errors.has('snmpTrapAddress1') || this.errors.has('snmpTrapAddress2') || this.errors.has('snmpTrapAddress3')) {
            isEnable = false
          }
        }
        if (this.data.config.version !== 3) {
          if (this.errors.has('snmpCommunity')) {
            isEnable = false
          }
        }
        if (this.data.config.version === 3) {
          if (this.errors.has('snmpUserName')) {
            isEnable = false
          }
          if (this.isItemChecked('snmpAuthEnable')) {
            if (this.errors.has('snmpAuthPassword')) {
              isEnable = false
            }
          }
          if (this.isItemChecked('snmpPrivacyEnable')) {
            if (this.errors.has('snmpPrivacyPassword')) {
              isEnable = false
            }
          }
        }
      }
      this.$store.commit('updateDataChanged', isEnable)
      return isEnable
    },
    onSelection: function (type) {
      if (type === 'snmpServiceEnable') {
        this.data.config.serviceEnable = !this.data.config.serviceEnable
      }
      if (this.isItemChecked('snmpServiceEnable')) {
        if (type === 'snmpAuthEnable') {
          this.data.config.security.authEnable = !this.data.config.security.authEnable
        } else if (type === 'snmpPrivacyEnable') {
          if (this.isItemChecked('snmpAuthEnable')) {
            this.data.config.security.privacyEnable = !this.data.config.security.privacyEnable
          }
        } else if (type === 'snmpTrapColdStart') {
          this.data.config.trapEvent.coldStart = !this.data.config.trapEvent.coldStart
        } else if (type === 'snmpTrapWarmStart') {
          this.data.config.trapEvent.warmStart = !this.data.config.trapEvent.warmStart
        } else if (type === 'snmpTrapLinkUp') {
          this.data.config.trapEvent.linkUp = !this.data.config.trapEvent.linkUp
        } else if (type === 'snmpTrapLinkDown') {
          this.data.config.trapEvent.linkDown = !this.data.config.trapEvent.linkDown
        }
      }
      this.checkValidation()
    },
    isItemChecked: function (type) {
      let result = true
      if (type === 'snmpServiceEnable') {
        result = this.data.config.serviceEnable
      } else if (type === 'snmpAuthEnable') {
        result = this.isItemChecked('snmpServiceEnable') && this.data.config.security.authEnable
      } else if (type === 'snmpPrivacyEnable') {
        result = this.isItemChecked('snmpAuthEnable') && this.data.config.security.privacyEnable
      } else if (type === 'snmpTrapEnable') {
        result = false
        if (this.isItemChecked('snmpServiceEnable')) {
          if (this.data.config.trapEvent.coldStart || this.data.config.trapEvent.warmStart || this.data.config.trapEvent.linkUp || this.data.config.trapEvent.linkDown) {
            result = true
          }
        }
      }
      return result
    },
    ...mapMutations([ 'openModal', 'closeModal' ]),
    ...mapActions([
      'getSystemSnmpService', 'getSystemSnmpCommunity', 'getSystemSnmpSecurity', 'getSystemSnmpTrapEvent', 'getSystemSnmpAddress', 'setSystemSnmpService', 'addSystemSnmpCommunity', 'setSystemSnmpCommunity', 'delSystemSnmpCommunity', 'addSystemSnmpSecurity', 'setSystemSnmpSecurity', 'delSystemSnmpSecurity', 'setSystemSnmpTrapEvent', 'addSystemSnmpAddress', 'setSystemSnmpAddress', 'delSystemSnmpAddress'
    ])
  },
  computed: {
    // ...mapGetters(['getTopModalName']),
    ...mapState({
      showInfoTips: state => state.app.showInfoTips,
      showFullLoading: state => state.module.showFullLoading,
      isDataChanged: state => state.app.isDataChanged,
      currentUser: state => state.module.currentUser,
      intervalTime: state => state.app.intervalTime
    })
  }
}
</script>

<style lang="scss" scoped>

.syssnmp {
  position: relative;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  >.content-body {
    padding: 20px 10px 10px 10px;
    div.content-body-header{
      padding-left: 20px !important;
    }
    .form {
      /deep/ .q-checkbox-label {
        width: auto;
        height: auto;
        cursor: pointer;
        .icon {
          display: inline-block;
          vertical-align: middle;
          color: #4C4C4C;
          font-size: 20px;
          font-weight: 400;
        }
        .text {
          display: inline-block;
          vertical-align: middle;
          margin-left: 0px;
        }
      }
      .table-row {
        > .title {
          width: auto;
          vertical-align: middle;
          display: inline-block;
        }
        >.item {
          vertical-align: top;
          display: inline-block;
        }
        .q-select {
          width: auto;
          vertical-align: middle;
          display: inline-block;
          margin-left: 2px;
        }
        input {
          width: 200px;
          vertical-align: middle;
          display: inline-block;
          margin-left: 2px;
        }
        input {
          color: #000000;
          height: 30px;
          font-size: 14px;
          line-height: 30px;
          font-weight: 400;
          font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
        }
        input::placeholder {
          color: #000000;
        }
        .info {
          width: auto;
          vertical-align: middle;
          display: inline-block;
        }
        .checkbox-wrapper {
          width: auto;
          display: inline-block;
          margin-left: 2px;
        }
      }
      .formRow.snmpService {
        /deep/ .q-checkbox-label {
          .text {
            color: #2F2F2F;
            font-size: 14px;
            line-height: 16px;
            font-weight: 500;
            font-family: 'Roboto-M', 'Microsoft JhengHei' !important;
          }
        }
      }
      .formRow.snmpConfig {
        padding-top: 20px;
        padding-left: 20px;
        .title {
          color: #000000;
          font-size: 14px;
          line-height: 16px;
          font-weight: 500;
          font-family: 'Roboto-M', 'Microsoft JhengHei' !important;
        }
        .q-select {
          min-width: 127px;
        }
      }
      .formRow.snmpCommunity {
        padding-top: 10px;
        padding-left: 30px;
        .title {
          color: #000000;
          font-size: 14px;
          line-height: 16px;
          font-weight: 400;
          font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
        }
      }
      .formRow.snmpSecurityConfig {
        padding-left: 30px;
        .table-row {
          padding-top: 10px;
          > .password {
            width: auto;
            display: inline-block;
            vertical-align: top;
            position: relative;
          }
        }
        .title {
          color: #000000;
          font-size: 14px;
          line-height: 16px;
          font-weight: 400;
          font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
        }
        /deep/ .q-checkbox-label {
          .text {
            color: #2F2F2F;
            font-size: 14px;
            line-height: 16px;
            font-weight: 400;
            font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
          }
          &.disabled {
            cursor: default;
            .text{
              color: #AEAEAE;
            }
          }
        }
      }
      .formRow.snmpTrapLevel {
        padding-top: 10px;
        .title {
          color: #000000;
          font-size: 14px;
          line-height: 16px;
          font-weight: 500;
          font-family: 'Roboto-M', 'Microsoft JhengHei' !important;
        }
        /deep/ .q-checkbox-label {
          .text {
            color: #2F2F2F;
            font-size: 14px;
            line-height: 16px;
            font-weight: 400;
            font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
          }
          &.disabled {
            cursor: default;
            .text{
              color: #AEAEAE;
            }
          }
        }
      }
      .formRow.snmpTrapAddress {
        .table-row {
          padding-top: 10px;
        }
        .title {
          color: #000000;
          font-size: 14px;
          line-height: 20px;
          font-weight: 500;
          font-family: 'Roboto-M', 'Microsoft JhengHei' !important;
        }
      }
      .disabled .table-row {
        .title {
          color: #AEAEAE;
        }
        input::placeholder {
          color: #AEAEAE;
        }
      }
      .formRow.snmpMIB {
        padding-top: 20px;
        padding-bottom: 10px;
        .title {
          color: #000000;
          font-size: 14px;
          line-height: 16px;
          font-weight: 500;
          font-family: 'Roboto-M', 'Microsoft JhengHei' !important;
        }
        .content {
          padding-top: 10px;
          color: #000000;
          font-size: 14px;
          line-height: 16px;
          font-weight: 400;
          font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
        }
        .q-button {
          margin-top: 10px;
        }
      }
    }
    .content-body-footer {
      top: calc(100% - 50px) !important;
      .q-button {
        min-width: 80px;
        height: 30px;
        font-family: 'Roboto-M', 'Microsoft JhengHei' !important;
      }
    }
    .scrollbar-body {
      height: calc(100% - 40px);
      padding: 0px 10px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/SystemSnmp.vue